import React, { useState, useEffect } from "react";
import { toggle } from "../../../../util/common";
import { IBusinessCreditReportResponse, BusinessCreditReportStatePII, IMonthlyDBTTrend } from "../../../../store/businessCreditReportService/types";
import Chart from "react-google-charts";
import moment from "moment-timezone";

interface IProps {
    bCreditReportData: IBusinessCreditReportResponse;
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
}
const TradePaymentMonthlyDbtTrends: React.FunctionComponent<IProps> = (props) => {
    const [chartData, setChartData] = useState([["Month", "Score"]]);

    const ensureDataFetched = () => {
        let dataForChart = [];
        dataForChart.push(["Month", "Score"]);
        let creditInquiries = props.reportObject?.businessCompanyReport?.monthly_dbt_trends;
        if (creditInquiries) {
            creditInquiries.sort(function (a: IMonthlyDBTTrend, b: IMonthlyDBTTrend) {
                let aScoreTime = moment(a.month, "YYYY-MM-DD").toDate().getTime();
                let bScoreTime = moment(b.month, "YYYY-MM-DD").toDate().getTime();
                return aScoreTime - bScoreTime;
            });

            creditInquiries.forEach((score) => {
                if (score.month && score.month !== "--" && score.days_beyond_terms && score.days_beyond_terms !== "--") {
                    dataForChart.push([moment(score.month, "YYYY-MM-DD").format("MMM DD, YYYY"), Number(score.days_beyond_terms)]);
                }
            });

            setChartData(dataForChart);
        }
    };
    useEffect(ensureDataFetched, [props.bCreditReportData]);

    var options = {
        title: "",
        hAxis: {
            title: "",
            titleTextStyle: {
                color: "#333",
            },
            textPosition: "none",
        },
        pointSize: 5,
        vAxis: {
            minValue: 0,
            //  maxValue:100,
            baselineColor: "#fff",
            gridlineColor: "#fff",
            textPosition: "none",
        },
        colors: ["#37A954"],
        height: 120,
        legend: {
            position: "none",
        },
        tooltip: {
            isHtml: true,
        },
        chartArea: {
            left: 8,
            top: 5,
            bottom: 16,
            right: 8,
            /*width: "100%",*/
            height: "100%",
        },
        series: {
            0: {
                type: "AreaChart",
                areaOpacity: 0.1,
            },
        },
    };
    return (
        <React.Fragment>
            <div className="link-item">
                {props.showAsAccordion ? (
                    <button
                        type="button"
                        aria-expanded="false"
                        className="link-button"
                        id="btn-monthly-dbt"
                        onClick={(e) => toggle("monthly-dbt-div", "btn-monthly-dbt")}
                    >
                        <span className="row link-item">
                            <span className="col-xs col-no-gutter link-text">
                                <span className="link-title">
                                    <span className="btn-toggle-status sr-only">Show</span> Monthly DBT Trends
                                </span>
                            </span>
                        </span>
                    </button>
                ) : (
                    <h5 className="report-sub-title">Monthly DBT Trends</h5>
                )}

                <div className="wallet-details" id="monthly-dbt-div" style={{ ...(props.showAsAccordion ? { display: "none" } : {}) }} aria-hidden="true">
                    <div className="box-content">
                        <div className="row full-width between-xs margin-bottom-l payment-table-header">
                            <div className="col-xs-12 flex-grow-null"></div>
                        </div>
                        {chartData && chartData.length > 1 ? (
                            <div className="credit-score-trend-chart" style={{ minHeight: "8rem" }}>
                                <div id="monthly-dbt-chart" className="m-chart-container"></div>
                                <Chart
                                    chartType="AreaChart"
                                    loader={<div>Loading Chart</div>}
                                    data={chartData}
                                    options={options}
                                    rootProps={{ "data-testid": "2" }}
                                    chartEvents={[
                                        {
                                            eventName: "ready",
                                            callback: ({ chartWrapper, google }) => {
                                                window.addEventListener(
                                                    "keydown",
                                                    (event) => {
                                                        if (event.key !== "Escape") return;
                                                        event.stopPropagation();
                                                        window.showtoolTip();
                                                    },
                                                    true
                                                );
                                                var chart = new google.visualization.AreaChart(document.getElementById("monthly-dbt-chart"));
                                                var svg = chart.getContainer().getElementsByTagName("svg");
                                                if (svg.length > 0) {
                                                    svg[0].setAttribute('role', 'img');
                                                    svg[0].setAttribute("aria-label", "Credit Score Tracker Bar Graph");
                                                }
                                            },
                                        },
                                    ]}
                                />
                            </div>
                        ) : (
                            <div className="box">
                                <div className="box-content text-align-center">There is no Monthly DBT Trends data available.</div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default TradePaymentMonthlyDbtTrends;
